import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import TableSimple from "ds/components/TableSimple";

import useSpaceliftVcsSearchFiles from "./useSearchFiles";
import useSearchFilesTableStore from "./useSearchFilesTableStore";
import { SPACELIFT_VCS_REPO_SEARCH_CELLS } from "./Cells";

const SpaceliftVcsRepoSearchResultsTable = () => {
  const { files, loading, hasMore, loadMore } = useSpaceliftVcsSearchFiles();

  return (
    <TableSimple
      data={files}
      store={useSearchFilesTableStore}
      ariaLabel="Search results"
      cellPerColumn={SPACELIFT_VCS_REPO_SEARCH_CELLS}
      loading={loading}
      itemIdKey="filePath"
      hasPagination={false}
      onLoadMore={hasMore ? loadMore : undefined}
      virtualize={files.length > 50}
      emptyState={
        <EmptyState
          title="No results"
          caption="Check the spelling or try something less specific."
          icon={EmptystateSearchNoResultsColored}
        />
      }
    />
  );
};

export default SpaceliftVcsRepoSearchResultsTable;
